<div id="billing-cycles-table">
  <app-ep-table
    [config]="config"
    [data]="billingCycles$ | async"
    (pageChange)="onPageChange($event)"
    data-cy="billing-cycles-table"
  ></app-ep-table>
</div>
